// extracted by mini-css-extract-plugin
export default {"preferencesDialogTitle":"generic-dialog_preferencesDialogTitle__4N9xn","titleText":"generic-dialog_titleText__qVnEw","dialogCloseButton":"generic-dialog_dialogCloseButton__6y+v5"};